import React, { useId } from 'react';
import styled from 'styled-components';
import { Color } from '../core';

interface ISideNavSection {
  href: string;
  isActive: boolean;
  label: string;
  id?: string;
}

const NavSection = styled.a`
  height: 50px;
  cursor: pointer;
  &:hover {
    background-color: ${Color.primaryBlack};
  }
  line-height: 50px;
  padding: 0px;
  background: transparent;
  border: none;
  width: 100%;
  font-family: Lato, sans-serif;
  font-size: 16px;
  display: block;
  text-decoration: none;
`;

const SideNavSectionLabel = styled.span<{ $isActive: boolean }>`
  color: ${Color.primaryGray};
  font-size: 0.875em;
  margin: 0;
  text-align: left;
  padding: 0px 20px;
  display: block;
  background-color: ${(props) => (props.$isActive ? Color.primaryBlack : 'inherit')};
`;

export const SideNavSection = React.memo<ISideNavSection>((props) => {
  const autoId = useId();
  return (
    <NavSection href={props.href}>
      <SideNavSectionLabel $isActive={props.isActive} id={props.id ?? autoId}>
        {props.label}
      </SideNavSectionLabel>
    </NavSection>
  );
});
